var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 39,
    viewBox: "0 0 30 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9025 0L20.7423 0.0109524L21.1577 0.0122573L29.8149 8.77004V28.3515C29.8149 29.9394 28.5205 31.2265 26.9238 31.2265H9.57714C7.98043 31.2265 6.68604 29.9394 6.68604 28.3515V2.88726C6.68604 1.29944 7.98043 0.0122573 9.57714 0.0122573L19.9011 0.0109524L19.9025 0ZM19.9011 1.6543L9.5771 1.6556C8.89279 1.6556 8.33805 2.20725 8.33805 2.88774V28.352C8.33805 29.0325 8.89279 29.5842 9.5771 29.5842H26.9237C27.608 29.5842 28.1628 29.0325 28.1628 28.352V9.92471L22.7936 9.86989C21.1969 9.86989 19.9025 8.58271 19.9025 6.99489L19.9011 1.6543ZM21.5552 6.99119V2.75391L27.0056 8.26711L22.8029 8.22338C22.11 8.22333 21.5552 7.67168 21.5552 6.99119Z",
    fill: "#A9A9A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8693 7L14.7091 7.01095L15.1245 7.01226L23.7817 15.77V35.3515C23.7817 36.9394 22.4873 38.2265 20.8906 38.2265H3.54394C1.94722 38.2265 0.652832 36.9394 0.652832 35.3515V9.88726C0.652832 8.29944 1.94722 7.01226 3.54394 7.01226L13.8679 7.01095L13.8693 7ZM13.8675 8.6543L3.54349 8.6556C2.85918 8.6556 2.30444 9.20725 2.30444 9.88774V35.352C2.30444 36.0325 2.85918 36.5842 3.54349 36.5842H20.8901C21.5744 36.5842 22.1292 36.0325 22.1292 35.352V16.9247L16.76 16.8699C15.1633 16.8699 13.8689 15.5827 13.8689 13.9949L13.8675 8.6543ZM15.5216 13.9912V9.75391L20.972 15.2671L16.7693 15.2234C16.0764 15.2233 15.5216 14.6717 15.5216 13.9912Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3bb11af21b3e839f4b4870219e6fb317.svg";
export { ForwardRef as ReactComponent };